import React from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Menu,
    MenuItem,
    Stack,
    TextField,
} from '@mui/material';
import {SOURCES_DIALOG_STACK_PROPS} from './sourcesDialogStackProps';

const SourcesFolderDialogs = ({
    menu,
    createDialog,
    renameDialog,
    removeDialog,
}) => {
    return (
        <React.Fragment>
            <Menu
                anchorEl={menu.anchorEl}
                open={Boolean(menu.anchorEl)}
                onClose={menu.onClose}
            >
                <MenuItem onClick={menu.onRename}>Rename</MenuItem>
                <MenuItem onClick={menu.onRemove}>Remove</MenuItem>
            </Menu>

            <Dialog open={createDialog.open} onClose={createDialog.onClose} fullWidth maxWidth="xs" {...SOURCES_DIALOG_STACK_PROPS}>
                <DialogTitle>Create folder</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} pt={1}>
                        <TextField
                            autoFocus
                            fullWidth
                            label="Folder name"
                            value={createDialog.value}
                            onChange={createDialog.onChange}
                            onKeyDown={createDialog.onKeyDown}
                            error={Boolean(createDialog.error) || createDialog.isTooLong}
                            helperText={createDialog.error || createDialog.helperText}
                        />

                        {!createDialog.userId && (
                            <Alert severity="warning">An authenticated user is required to create folders.</Alert>
                        )}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={createDialog.onClose} disabled={createDialog.isSubmitting}>Cancel</Button>
                    <Button onClick={createDialog.onSubmit} variant="contained" disabled={createDialog.isSubmitDisabled}>
                        {createDialog.isSubmitting ? 'Creating…' : 'Create'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={renameDialog.open} onClose={renameDialog.onClose} fullWidth maxWidth="xs" {...SOURCES_DIALOG_STACK_PROPS}>
                <DialogTitle>Rename folder</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} pt={1}>
                        <TextField
                            autoFocus
                            fullWidth
                            label="Folder name"
                            value={renameDialog.value}
                            onChange={renameDialog.onChange}
                            onKeyDown={renameDialog.onKeyDown}
                            error={Boolean(renameDialog.error)}
                            helperText={renameDialog.error || renameDialog.helperText}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={renameDialog.onClose} disabled={renameDialog.isSubmitting}>Cancel</Button>
                    <Button onClick={renameDialog.onSubmit} variant="contained" disabled={renameDialog.isSubmitDisabled}>
                        {renameDialog.isSubmitting ? 'Saving…' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={removeDialog.open} onClose={removeDialog.onClose} fullWidth maxWidth="xs" {...SOURCES_DIALOG_STACK_PROPS}>
                <DialogTitle>Remove folder</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} pt={1}>
                        <DialogContentText>
                            Remove folder “{removeDialog.folderName || 'Untitled folder'}”?
                        </DialogContentText>
                        {removeDialog.error && <Alert severity="error">{removeDialog.error}</Alert>}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={removeDialog.onClose} disabled={removeDialog.isSubmitting}>Cancel</Button>
                    <Button
                        onClick={removeDialog.onSubmit}
                        color="error"
                        variant="contained"
                        disabled={removeDialog.isSubmitDisabled}
                    >
                        {removeDialog.isSubmitting ? 'Removing…' : 'Remove'}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default React.memo(SourcesFolderDialogs);

